import { functions } from 'common/config/Firebase';
import showPDFSignUseCase from 'tasks/services/sign/showPDFSignUseCase';
import findClientByTask from 'tasks/services/sign/findClientByTask';
import { renderMoney } from 'common/services/util';

const sendInformeEmailUseCase = async (taskSelected) => {
  const clientData = await findClientByTask(taskSelected.data.dni);
  const clientEmail = clientData.mail;

  if (!clientEmail) {
    throw new Error("Este cliente no tiene email configurado");
  }

  // URL del PDF del informe (como antes)
  const url = await showPDFSignUseCase(
    taskSelected.data,
    clientData,
    taskSelected.detail,
    4,
    null
  );

  // Número de informe (usamos la referencia de la reparación)
  const informeNumber =
    taskSelected.data.reference || taskSelected.data.id || "";

  // Nombre del cliente para el fichero
  const safeClientName = (clientData.name || "CLIENTE")
    .trim()
    .replace(/ /g, "_");

  const filename = `INFORME-${informeNumber}-${safeClientName}.pdf`;

  const budget = Number(taskSelected.data.budget || 0);
  const priceWithVat = renderMoney(budget);
  const ivaIncluded = taskSelected.data.iva !== false;

  // Enviar email vía Cloud Function
  const sendDocumentEmail = functions.httpsCallable("sendDocumentEmail");

  const result = await sendDocumentEmail({
    to: clientEmail,
    pdfUrl: url,
    filename,
    type: "informe",
    meta: {
      repairNumber: taskSelected.data.reference,
      deviceName:   taskSelected.data.deviceName,
      serialNumber: taskSelected.data.serialNumber || taskSelected.data.imei,
      priceWithVat,
      ivaIncluded,
    },
  });

  return result;
};

export default sendInformeEmailUseCase;